import React from 'react';

const Spinner = () => {
    return (
        <div className="app-skeleton" role="status" aria-live="polite">
            <style>{`
                .app-skeleton{position:fixed;inset:0;width:100%;height:100%;overflow:hidden;background-color:#FDFCF5;z-index:1;display:flex;align-items:center;justify-content:center;}
                .app-skeleton__gradient{position:absolute;inset:-10%;width:120%;height:120%;background:linear-gradient(120deg,#f3d9b1 0%,#fdfcf5 30%,#cfd8e3 55%,#eef1f5 75%,#f3d9b1 100%);background-size:250% 250%;filter:blur(60px) saturate(115%);animation:app-skeleton-shift 6s ease-in-out infinite;opacity:0.9;}
                @keyframes app-skeleton-shift{0%{background-position:0% 50%;}50%{background-position:100% 50%;}100%{background-position:0% 50%;}}
                .app-skeleton__spinner{position:relative;width:44px;height:44px;border-radius:50%;border:3px solid rgba(20,24,30,0.12);border-top-color:#14181E;animation:app-skeleton-spin 0.8s linear infinite;}
                @keyframes app-skeleton-spin{to{transform:rotate(360deg);}}
                .app-skeleton__sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;}
                @media (prefers-reduced-motion: reduce){.app-skeleton__gradient{animation:none;}.app-skeleton__spinner{animation-duration:1.6s;}}
            `}</style>
            <div className="app-skeleton__gradient" />
            <div className="app-skeleton__spinner" />
            <span className="app-skeleton__sr-only">Loading...</span>
        </div>
    );
};

export default Spinner;